// extracted by mini-css-extract-plugin
export default {"dialog":"Xyz4RncaxUMeGGo6"};